/* バランスサーチ検索項目用定数を定義する */

export const capacity = [
  {
    val: {
      min: 1,
      max: 99
    },
    name: '1g - 99g'
  },
  {
    val: {
      min: 100,
      max: 299
    },
    name: '100g - 299g'
  },
  {
    val: {
      min: 300,
      max: 499
    },
    name: '300g - 499g'
  },
  {
    val: {
      min: 500,
      max: 999
    },
    name: '500g - 999g'
  },
  {
    val: {
      min: 1000,
      max: 2999
    },
    name: '1kg - 2.9kg'
  },
  {
    val: {
      min: 3000,
      max: 4999
    },
    name: '3kg - 4.9kg'
  },
  {
    val: {
      min: 5000,
      max: 9999
    },
    name: '5kg - 9.9kg'
  },
  {
    val: {
      min: 10000,
      max: 49999
    },
    name: '10kg - 49.9kg'
  },
  {
    val: {
      min: 50000,
      max: null
    },
    name: '50kg - '
  }
]

export const minDisplay = [
  '0.01mg',
  '0.1mg',
  '0.0002g',
  '0.001g',
  '0.01g',
  '0.05g',
  '0.1g',
  '1g'
]

export const specs = [
  {
    id: 'unibloc-installed',
    name: 'unibloc',
    val: 'unibloc',
    check: false
  },
  {
    id: 'backlight-display',
    name: 'light',
    val: 'LCD_Light',
    check: false
  },
  {
    id: 'menu-operation-key',
    name: 'menu',
    val: 'S_plus',
    check: false
  },
  {
    id: 'dry-battery',
    name: 'dry',
    val: 'BAT',
    check: false
  },
  {
    id: 'dual-range',
    name: 'dual',
    val: 'dual',
    check: false
  }
]

export const funcs = [
  {
    id: 'easy-setting',
    name: 'easy',
    val: 'SS',
    check: false
  },
  {
    id: 'internal-calibration',
    name: 'internal',
    val: 'kousei',
    check: false
  },
  {
    id: 'bulk-in-clock',
    name: 'clock',
    val: 'clock',
    check: false
  },
  {
    id: 'windows-direct',
    name: 'windows',
    val: 'windows',
    check: false
  },
  {
    id: 'iso-calibration-report',
    name: 'iso',
    val: 'iso',
    check: false
  }
]

export const apps = [
  {
    id: 'animal',
    name: 'animal',
    val: 'Animal',
    check: false
  },
  {
    id: 'specific-gravity-measurement',
    name: 'gravity',
    val: 'hizyu',
    check: false
  },
  {
    id: 'comparator-function',
    name: 'comparator',
    val: 'Comparator',
    check: false
  },
  {
    id: 'formulation-mode',
    name: 'formulation',
    val: 'Formulation',
    check: false
  },
  {
    id: 'piece-counting',
    name: 'piece',
    val: 'object',
    check: false
  },
  {
    id: 'carat-measurement',
    name: 'carat',
    val: 'Carat',
    check: false
  }
]
